import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import BanDoDeXuatPhanBonApi from '../../api/BanDoDeXuatPhanBonApi';
import LoaiCayApi from '../../api/LoaiCayApi';
import MuaVuApi from '../../api/MuaVuApi';

export const ModalEditThongTin = (props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        props.closeThongTin();
        setShow(false)
    };
    const { register, handleSubmit, reset } = useForm();
    const [selectedOption, setSelectedOption] = useState();
    const [selectedOptionMuaVu, setSelectedOptionMuaVu] = useState();
    const [listLoaiCay, setLoaiCay] = useState([]);
    const [listMuaVu, setMuaVu] = useState([]);
    const [gid, setGid] = useState('');
    const [listRow,setListRow] = useState([{Count:0,Id:0,LoaiPhan:'',KhoiLuong:''}]);
    const [listRowDefault,setListRowDefault] = useState([{Count:0,Id:0,LoaiPhan:'',KhoiLuong:''}]);
    const [createRow,setCreateRow] = useState(false);
    const kieuBanDo = 4;
    const [rowCount,setRowCount] = useState(1);
    const [listObject,setListObject] = useState([]);
    const [modeEdit,setModeEdit] = useState(false);

    const saveData = (data) => {
        let str = '';
        if (selectedOption) {
            data.MaLoai = selectedOption.value;
        }
        if (selectedOptionMuaVu) {
            data.MaMuaVu = selectedOptionMuaVu.value;
        }
        if (data.MaLoai !== undefined)
        {
            data.gid = gid;
            data.geometry=props.thongTin.geometry;

            listRow.forEach(x =>{
                if(x.Id !==0)
                {
                    listObject.forEach(p=>{
                        if(x.Id === p.Id)
                        {
                            if(str ==='')
                            {
                            str += x.Id
                            }
                            else
                            {
                            str += ',' + x.Id
                            }
                        }
                    })
                }
            })

            BanDoDeXuatPhanBonApi.delete(str,gid,selectedOption.value);


            listRow.forEach(x =>{
            data.Id = x.Id;
            data.LoaiPhan = x.LoaiPhan;
            data.KhoiLuong = x.KhoiLuong;
            BanDoDeXuatPhanBonApi.updateThongTin(data).then(() => {
                setShow(false);
            })
            props.saveSuccess();

            
        })
        }
    }


    const addNewRow = () =>{
        let list = listRow;
        list.push({Count:rowCount,Id:0, LoaiPhan: '',KhoiLuong:''})
        setListRow([...list]);
        setRowCount(rowCount+1);
    }

    const deleteRow = (item) =>{
            let index = listRow.indexOf(item);
            let list = [...listRow];
            if (index !== -1)
            {
                list.splice(index,1);
                setListRow([...list]);
            } 
            
      }

    useEffect(()=>{
        setRowCount(rowCount);
    },[rowCount])






    useEffect(() => {
        if (props.showEdit === true) {
            setGid(props.thongTin.gid);
            loadThongTin();
            setSelectedOption('');
            setSelectedOptionMuaVu('');
            setCreateRow(false);
            setShow(true);
            setModeEdit(props.modeEdit);


 /*            var index = listLopMau.findIndex(x => x.value == props.thongTin.tnh);
            setSelectedOption(listLopMau[index]); */
        }

    }, [props.showEdit]);

    const loadThongTin = async () =>{
        if(props.thongTin.gid !=='')
        {
            const res = await BanDoDeXuatPhanBonApi.GetThongTin(props.thongTin.gid);
            setListObject(res.Items);
        }

    } 

   
    const onChangeLoaiCay = (e) => {
        setSelectedOption(e);
        let list = [];
        setRowCount(1);
        listObject.map(x => {
            if(x.MaLoai === e.value)
            {
                list.push({'Count':rowCount,'Id':x.Id,'LoaiPhan':x.LoaiPhan,'KhoiLuong':x.KhoiLuong});
                setRowCount(rowCount + 1);
            }
        })
        if(list.length === 0)
        {
            list.push({Count:0,Id:0,LoaiPhan:'',KhoiLuong:''});
        }
        setListRow(list);
        setCreateRow(true);
    }

    const onChangeMuaVu = (e) => {
        setSelectedOptionMuaVu(e);
    }


    function loadLoaiCay() {
        LoaiCayApi.getLoaiCay().then((response) => {
            let list = [];
            list.push({ value: '', label: 'Chọn cây' });
            response.forEach(item => {
               /*  if(item.Type===1 || item.Type===kieuBanDo) */
                list.push({ value: item.MaLoai, label: item.TenLoai });
            })
            setLoaiCay(list);
        })
    }

    const onChangeLP = (x,e) =>{
        if(modeEdit === true)
        {
        listRow.map(p =>{
            if(p === x)
            {
                p.LoaiPhan = e.target.value;
            }
        });
        setListRow([...listRow]);
        }
    }

    const onChangeKL = (x,e) =>{
        if(modeEdit === true)
        {
            listRow.map(p =>{
                if(p === x)
                {
                    p.KhoiLuong = e.target.value;
                }
            });
            setListRow([...listRow]);
        }
        
    }


    function loadMuaVu() {
        MuaVuApi.getMuaVu().then((response) => {
            let list = [];
            list.push({ value: '', label: 'Chọn mùa vụ' });
            response.forEach(item => {
                /* if(item.Type===1 || item.Type===kieuBanDo) */
                list.push({ value: item.MaLoai, label: item.TenLoai });
            })
            setMuaVu(list);
        })
    }

    useEffect(() => {
        loadLoaiCay();
        loadMuaVu();
    }, []);

    return (
        <div className="card shadow mb-1">

            <Modal show={show} onHide={handleClose} animation={false} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Thông tin</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="user" onSubmit={handleSubmit(saveData)}>
                        <input name="Id" hidden={true} ref={register}></input>
                        <div className="form-group row">                           
                            <label className="col-sm-2 col-form-label">Loai cây</label>
                            <div className="col-sm-10">
                                <Select
                                    className="select"
                                    name="MaLoai"
                                    placeholder="Chọn cây"
                                    defaultValue={selectedOption}
                                    onChange={onChangeLoaiCay}
                                    options={listLoaiCay}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                        <label className="col-sm-2 col-form-label">Mùa vụ </label>
                            <div className="col-sm-10">
                                <Select
                                    className="select"
                                    name="MaMuaVu"
                                    placeholder="Chọn mùa vụ"
                                    defaultValue={selectedOptionMuaVu}
                                    onChange={onChangeMuaVu}
                                    options={listMuaVu}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Huyện</label>
                            <div className="col-sm-4">
                                <input name="TenHuyen" type="text" value={props.thongTin.huyen} className="form-control" placeholder="Tên huyện"/>
                            </div>
                            <label className="col-sm-2 col-form-label">Xã</label>
                            <div className="col-sm-4">
                                <input name="TenXa" type="text" value={props.thongTin.xa} className="form-control" placeholder="Tên xã" ref={register} />
                            </div>
                        </div>
                        
                        {
                            createRow === true?
                            listRow.map((x,key)=>{
                                return(
                                        <div className="form-group row" key={key}>
                                            <div className="col-sm-3" hidden={true}>
                                                <input name={"Id" + x.Id } value={x.Id} type="text" className="form-control" placeholder="Id"  />
                                            </div>
                                            <label className="col-sm-2 col-form-label">Loại phân</label>
                                            <div className="col-sm-3">
                                                <input name={"LoaiPhan" + x.Count } value={x.LoaiPhan} type="text" onChange={(e) => onChangeLP(x,e)} className="form-control" placeholder="Loại phân"   />
                                            </div>
                                            <div className="col-sm-1"></div>
                                            <label className="col-sm-2 col-form-label">Khối lượng</label>
                                            <div className="col-sm-3">
                                                <input name={"KhoiLuong" + x.Count} value={x.KhoiLuong} type="text" onChange={(e) => onChangeKL(x,e)} className="form-control" placeholder="Khối lượng"  />
                                            </div>
                                            <div className="col-sm-1">
                                            <input type="button"  class="btn btn-sm btn-danger" onClick={() => deleteRow(x)} hidden={!modeEdit} value="Xóa"/>
                                            </div>
                                        </div>
                                )
                            })
                            : listRowDefault.map((x,key)=>{
                                return(
                                    <div className="form-group row" key={key}>
                                            <div className="col-sm-3" hidden={true}>
                                                <input name={"Id" + x.Id } value={x.Id} type="text" className="form-control" placeholder="Id"/>
                                            </div>
                                            <label className="col-sm-2 col-form-label">Loại phân</label>
                                            <div className="col-sm-3">
                                                <input name={"LoaiPhan" + x.Count } value={x.LoaiPhan} type="text" onChange={(e) => onChangeLP(x,e)} className="form-control" placeholder="Loại phân"/>
                                            </div>
                                            <div className="col-sm-1"></div>
                                            <label className="col-sm-2 col-form-label">Khối lượng</label>
                                            <div className="col-sm-3">
                                                <input name={"KhoiLuong" + x.Count}  value={x.KhoiLuong} type="text" onChange={(e) => onChangeKL(x,e)} className="form-control" placeholder="Khối lượng"/>
                                            </div>
                                            <div className="col-sm-1">
                                            <input type="button"  class="btn btn-sm btn-danger" onClick={() => deleteRow(x)} hidden={!modeEdit} value="Xóa"/>
                                            </div>
                                        </div>
                                )
                            })
                        }
                        <div className="form-group row">
                            <div className="col-sm-2">
                            </div>
                            <div className="col-sm-8">
                                <input type="button"  class="btn btn-sm btn-outline-primary mr-auto" onClick={addNewRow} hidden={!modeEdit} value="Thêm dòng"/>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" size="sm" onClick={handleSubmit(saveData)} hidden={!modeEdit}>
                        Lưu</Button>
                    <Button variant="danger" size="sm" onClick={handleClose}>
                        Hủy</Button>
                </Modal.Footer>
            </Modal>

        </div>

    )
}
